// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.image {
  border: 1px solid lightgray;
  border-radius: 8px;
}
div.advertisement-one {
  box-shadow: var(--shadow-4);
  border: 1px solid var(--shadow-4);
  border-radius: 8px;
  background-image: url("/assets/images/advertisement-one.png");
  background-repeat: no-repeat;
  background-position: right;
  height: 145px;
  padding-top: 0.8rem;
  padding-left: 1.4rem;
}
div.advertisement-one .fully-certified {
  text-transform: uppercase;
  color: var(--primary);
  font-size: smaller;
}
div.advertisement-one .ready-for-solar {
  font-size: x-large;
  color: var(--primary);
}
div.advertisement-one button {
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/common/advertisements/ready-for-solar/ready-for-solar.component.scss"],"names":[],"mappings":"AACE;EACE,2BAAA;EACA,kBAAA;AAAJ;AAGE;EACE,2BAAA;EACA,iCAAA;EACA,kBAAA;EACA,6DAAA;EACA,4BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AADJ;AAGI;EACE,yBAAA;EACA,qBAAA;EACA,kBAAA;AADN;AAII;EACE,kBAAA;EACA,qBAAA;AAFN;AAKI;EACE,gBAAA;AAHN","sourcesContent":["div {\n  &.image {\n    border: 1px solid lightgray;\n    border-radius: 8px;\n  }\n\n  &.advertisement-one {\n    box-shadow: var(--shadow-4);\n    border: 1px solid var(--shadow-4);\n    border-radius: 8px;\n    background-image: url('/assets/images/advertisement-one.png');\n    background-repeat: no-repeat;\n    background-position: right;\n    height: 145px;\n    padding-top: 0.8rem;\n    padding-left: 1.4rem;\n\n    .fully-certified {\n      text-transform: uppercase;\n      color: var(--primary);\n      font-size: smaller;\n    }\n\n    .ready-for-solar {\n      font-size: x-large;\n      color: var(--primary);\n    }\n\n    button {\n      margin-top: 1rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
